module.exports = __webpack_public_path__ + "media/images/icons/v2/info-circle-789421630eebd9c21752ecb7b8d1cdfa.svg";